export default __webpack_public_path__ + "locales/sr-Latn-RS/ConnectDialog.json?hash=748129a24184c01cc43c936f9927fb03";